import { render, staticRenderFns } from "./PaymentFpx.vue?vue&type=template&id=47d66564"
import script from "./PaymentFpx.vue?vue&type=script&lang=js"
export * from "./PaymentFpx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports